








































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { get_agency_invoice_detail } from '@/api/invoice';
import { stringFromIDate } from '@/utils/index';

@Component({
  name: 'InvoiceAgencyDetailPaymentRecord',
})
export default class extends Vue {
  @Prop({ default: true }) flat!: boolean;
  @Prop({ default: false }) accountingSlipFinshed!: boolean;
  @Prop({ required: true }) currency!: string;
  @Prop({ required: true }) totalPrice!: number;
  @Prop({ required: true })
  private bankTransferDetail!: get_agency_invoice_detail.BankTransferDetail;

  get discrepancy() {
    if (this.bankTransferDetail) {
      return this.bankTransferDetail.actualAmount >= this.totalPrice
        ? `${(
            this.bankTransferDetail.actualAmount - this.totalPrice
          ).toLocaleString()}`
        : `▲${(
            this.totalPrice - this.bankTransferDetail.actualAmount
          ).toLocaleString()}`;
    }
    return '';
  }

  get paymentDate() {
    if (this.bankTransferDetail) {
      return stringFromIDate(this.bankTransferDetail.date);
    }
    return '';
  }

  get paymentAccont() {
    if (this.bankTransferDetail) {
      return `${this.bankTransferDetail.bankName} ${this.bankTransferDetail.branchName} ${this.bankTransferDetail.accountName}`;
    }
    return '';
  }
}
